export interface ITestInvoiceNumberResponse {
    valid: boolean;
    error: InvoiceNumberError[];
}

export enum InvoiceNumberError {
    /**
     * The invoice does not comply with the expected format.
     */
    INVALID_FORMAT = 'INVALID_FORMAT',
    /**
     * The invoice number is already in use.
     */
    ALREADY_EXISTS = 'ALREADY_EXISTS',
}
